import React from "react";
import { useResponsive } from "../../../../hooks/useResponsive";
import { Tooltip, Typography } from "@mui/material";
import { TooltipName } from "../../../../utils/Enums";
import { DeleteIcone } from "../../../../components/UI/Icons";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { useDeleteCard } from "./hooks/useDeleteCard";

const DeleteCard = ({
  cardId,
  boardId,
  kanbanCardDelete,
  setShowDetails,
  className = "",
  DeleteIconStyle = "",
}) => {
  const isMobile = useResponsive("down", "md");
  const {
    handleCardDelete,
    handleClose,
    handleDeleteConfirm,
    loading,
    showDelete,
  } = useDeleteCard({ boardId, cardId, setShowDetails });

  return (
    <span className={`d-flex align-items-center  ${className}`}>
      {showDelete && (
        <FormDialog
          open={showDelete}
          handleClose={handleClose}
          loading={loading}
          handleSubmit={handleDeleteConfirm}
          buttonTxt="Delete"
          title="Confirmation: Delete Task"
          alignActions="center"
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure you want to delete this item? This action cannot be
            undone.
          </Typography>
        </FormDialog>
      )}
      {isMobile ? (
        <>
          <Typography
            className={"workflow_steps d-flex align-items-center delete-card"}
            onClick={(e) => {
              e.stopPropagation();
              handleCardDelete(e);
            }}>
            <DeleteIcone className={"delete-card-button mr-2"} />
            Delete Card
          </Typography>
        </>
      ) : (
        <Tooltip title={TooltipName.KANBAN_CARD.DELETE_THIS_TASK}>
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleCardDelete(e);
            }}
            className={kanbanCardDelete ? "delete-card" : "delete-card-button"}>
            <DeleteIcone className={DeleteIconStyle} />
          </div>
        </Tooltip>
      )}
    </span>
  );
};

export default React.memo(DeleteCard);
